import { useEffect } from 'react';

import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import getAndroidApp from '../../res/images/android_app.png';
import getAppleApp from '../../res/svg/apple_app.svg';

const StyledContainer = styled(Box)(() => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const MobileAppLink = styled('a')(() => ({
  borderRadius: '13px',
  width: '200px',
  display: 'block',
  margin: '0 auto',
  '& img': {
    width: '200px',
  },
}));

const SupportPageComponent = () => {
  useEffect(() => {
    document.title = 'Support';
  }, []);

  return (
    <StyledContainer>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Contact Carson Support
      </Typography>

      <Link
        href="tel:+1 646 661 2250"
        data-content="+1 646 661 2250"
        data-type="phone"
      >
        (646) 661-2250 ex 2
      </Link>

      <Link
        href="mailto:support@carson.live?subject=Need support from Carson"
        target="_self"
        data-content="support@carson.live"
        data-type="mail"
      >
        support@carson.live
      </Link>
      <br />
      <Link
        href="https://carsonhelp.zendesk.com/hc/en-us"
        target="_blank"
        rel="noopener"
        sx={{ textAlign: 'center' }}
      >
        Visit the Carson Support Desk
      </Link>
      <Box sx={{ mt: '2rem' }}>
        <Typography variant="h6" sx={{ textAlign: 'center', my: '1rem' }}>
          Download Resident App
        </Typography>
        <MobileAppLink href="https://apps.apple.com/us/app/carson-living/id1273755261">
          <img src={getAppleApp} alt="Download on the App Store" />
        </MobileAppLink>

        <MobileAppLink href="https://play.google.com/store/apps/details?id=live.carson.app">
          <img alt="Get it on Google Play" src={getAndroidApp} />
        </MobileAppLink>
      </Box>
    </StyledContainer>
  );
};

export default SupportPageComponent;
